<template>
  <v-row class="mb--100">
    <!-- Start Blog Area  -->
    <v-col lg="4" md="4" sm="6" cols="12">
      <div class="blog blog-style--1 bg_color--1">
        <div class="text-center mb-30">
          <div class="service-cap" style="margin-top: 2%;">
            <v-row align="center" justify="center">
              <v-col cols="auto" align="center" justify="center">
                <div class="imgBlog">
                  <img
                    src="@/assets/images/logo/logo.png"
                    style="width:130px;"
                  />
                </div>
                <br /><br />
                <h4><b>Καύσιμα &amp; Υπηρεσίες</b></h4>
                <br /><br />
                <div class="paragraphBlog">
                  <p>
                    H <i><b>ελίν</b></i> σε επιβραβεύει για κάθε λίτρο καυσίμου
                    και για κάθε προϊόν/υπηρεσία που επιλέγεις.
                  </p>
                </div>
              </v-col>
            </v-row>
            <template>
              <v-row justify="space-around">
                <v-col cols="auto" align="center" justify="center">
                  <v-dialog transition="dialog-top-transition" width="auto ">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="button_beaut"
                        color="#004e96"
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        >Δες περισσότερα</v-btn
                      >
                    </template>
                    <template>
                      <v-card>
                        <center>
                          <h4 style="padding-top: 25px;">
                            Καύσιμα & Υπηρεσίες ελίν
                          </h4>
                        </center>
                        <!-- <v-toolbar
                                        ><h4>Καύσιμα & Υπηρεσίες ελίν</h4></v-toolbar> -->
                        <v-img
                          :contain="true"
                          src="@/assets/images/blog/kausima_image2.png"
                          class="col-md-12 col-lg-12 col-sm-12 col-12 text-center"
                        ></v-img>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </template>
          </div>
        </div>
      </div>
    </v-col>

    <v-col lg="4" md="4" sm="6" cols="12">
      <div class="blog blog-style--1 bg_color--1">
        <div class="text-center mb-30">
          <div class="service-cap" style="margin-top: 2%;">
            <v-row align="center" justify="center">
              <v-col cols="auto" align="center" justify="center">
                <div class="imgBlog">
                  <img
                    src="@/assets/images/blog/lip.png"
                    style="width:110px;"
                  />
                </div>
                <br /><br />
                <h4><b>Λιπαντικά</b></h4>
                <br /><br />
                <div class="paragraphBlog">
                  <p>
                    Aγόρασε λιπαντικά <i><b>ελίν</b></i> και επωφελήσου άμεσα με
                    πόντους <b><i>ελίν up</i> επιβράβευση</b> για κάθε ευρώ
                    αγορών.
                  </p>
                </div>
              </v-col>
            </v-row>
            <template>
              <v-row justify="space-around">
                <v-col cols="auto" align="center" justify="center">
                  <v-dialog transition="dialog-top-transition" width="auto ">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="button_beaut"
                        color="#004e96"
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        >Δες περισσότερα</v-btn
                      >
                    </template>
                    <template>
                      <v-card>
                        <!-- <v-toolbar
                                        ><h4>Καύσιμα & Υπηρεσίες ελίν</h4></v-toolbar> -->
                        <center>
                          <h4 style="padding-top: 25px;">
                            Καύσιμα & Υπηρεσίες ελίν
                          </h4>
                        </center>

                        <v-img
                          :contain="true"
                          src="@/assets/images/blog/kausima_image2.png"
                          class="col-md-12 col-lg-12 col-sm-12 col-12 text-center"
                        ></v-img>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </template>
          </div>
        </div>
      </div>
    </v-col>
    <v-col lg="4" md="4" sm="6" cols="12">
      <div class="blog blog-style--1 bg_color--1">
        <div class="text-center mb-30">
          <div class="service-cap" style="margin-top: 2%;">
            <v-row align="center" justify="center">
              <v-col cols="auto" align="center" justify="center">
                <div class="imgBlog">
                  <img
                    src="@/assets/images/blog/electriconn.png"
                    style="width:170px;"
                  />
                </div>
                <br /><br />
                <h4><b>Ηλεκτρική Ενέργεια Φυσικό Αέριο</b></h4>
                <br />
                <div class="paragraphBlog">
                  <p>
                    Tώρα και οι πελάτες της Ηλεκτρικής Ενέργειας αλλά και του
                    Φυσικού Αερίου απολαμβάνουν προνόμια.
                  </p>
                </div>
              </v-col>
            </v-row>
            <template>
              <v-row justify="space-around">
                <v-col cols="auto" align="center" justify="center">
                  <v-dialog transition="dialog-top-transition" width="auto ">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="button_beaut"
                        color="#004e96"
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        >Δες περισσότερα</v-btn
                      >
                    </template>
                    <template>
                      <v-card>
                        <!-- <v-toolbar
                                        ><h4>Ηλεκτρική Ενέργεια / Φυσικό Αέριο</h4></v-toolbar> -->
                        <center>
                          <h4 style="padding-top: 25px;">
                            Ηλεκτρική Ενέργεια / Φυσικό Αέριο
                          </h4>
                        </center>

                        <v-img
                          :contain="true"
                          src="@/assets/images/blog/Site_elin_gif.gif"
                          class="col-md-12 col-lg-12 col-sm-12 col-12 text-center"
                        ></v-img>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </template>
          </div>
        </div>
      </div>
    </v-col>
    <v-col lg="2" md="2" sm="12" cols="12" class="d-sm-none d-md-block"></v-col>
    <v-col lg="4" md="4" sm="6" cols="12">
      <div class="blog blog-style--1 bg_color--1">
        <div class="text-center mb-30">
          <div class="service-cap" style="margin-top: 2%;">
            <v-row align="center" justify="center">
              <v-col cols="auto" align="center" justify="center">
                <div class="imgBlog">
                  <img
                    class="mt--9"
                    src="@/assets/images/blog/fygame.png"
                    style="width:170px;"
                  />
                </div>
                <br /><br />
                <h4><b>figame.gr</b></h4>
                <br />
                <div class="paragraphBlog">
                  <p>
                    Κάθε καταναλωτής που αγοράζει αεροπορικά εισιτήρια κερδίζει
                    πόντους <b><i>ελίν up</i> επιβράβευση</b> .
                  </p>
                </div>
              </v-col>
            </v-row>
            <template>
              <v-row justify="space-around">
                <v-col cols="auto" align="center" justify="center">
                  <v-dialog transition="dialog-top-transition" width="auto ">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="button_beaut"
                        color="#004e96"
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        >Ξεκινήστε σήμερα</v-btn
                      >
                    </template>
                    <template>
                      <v-card>
                        <!-- <v-toolbar
                                        ><h4>figame.gr</h4></v-toolbar> -->
                        <center>
                          <h4 style="padding-top: 25px;">figame.gr</h4>
                        </center>

                        <v-img
                          :contain="true"
                          src="@/assets/images/blog/figamein.png"
                          class="col-md-12 col-lg-12 col-sm-12 col-12 text-center"
                        ></v-img>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </template>
          </div>
        </div>
      </div>
    </v-col>
    <!-- <v-col lg="4" md="4" sm="6" cols="12">
      <div class="blog blog-style--1 bg_color--1">
        <div class="text-center mb-30">
          <div class="service-cap" style="margin-top: 2%;">
            <v-row align="center" justify="center">
              <v-col cols="auto" align="center" justify="center">
                <div class="imgBlog">
                  <img
                    src="@/assets/images/blog/groupama.png"
                    style="width:170px;"
                  />
                </div>
                <br /><br />
                <h4><b>Groupama</b></h4>
                <br />
                <div class="paragraphBlog">
                  <p>
                    Με κάθε νέα ασφάλιση groupama κερδίζετε 500 πόντους
                    <b><i>ελίν up</i> επιβράβευση</b> .
                  </p>
                </div>
              </v-col>
            </v-row>
            <template>
              <v-row justify="space-around">
                <v-col cols="auto" align="center" justify="center">
                  <v-dialog
                    transition="dialog-top-transition"
                    width="auto "
                    style="overflow:visible;scroll-y:none"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="button_beaut"
                        color="#004e96"
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        >Ξεκινήστε σήμερα</v-btn
                      >
                    </template>
                    <template>
                      <v-card>
                        <center>
                          <h4 style="padding-top: 25px;">Groupama</h4>
                        </center>

                        <p></p>
                        <p style="text-align: center;">
                          Κάθε πελάτης Groupama που θα κατεβάσει για πρώτη φορά
                          την <br />
                          Εφαρμογή Roadcube, η Groupαma τον επιβραβεύει με
                          <br />
                          <b style="color: #104788;"
                            >500 πόντους <i>ελίν up</i> επιβράβευση</b
                          >
                        </p>
                        <v-img
                          contain="true"
                          src="@/assets/images/blog/Site_Elin_GROUPAMA.jpg"
                          class="col-md-12 col-lg-12 col-sm-12 col-12 text-center"
                        ></v-img>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </template>
          </div>
        </div>
      </div>
    </v-col> -->
    <!-- <v-col lg="2" md="2" sm="12" cols="12"></v-col> -->
    <v-col lg="4" md="4" sm="6" cols="12">
      <div class="blog blog-style--1 bg_color--1">
        <div class="text-center mb-30">
          <div class="service-cap" style="margin-top: 2%;">
            <v-row align="center" justify="center">
              <v-col cols="auto" align="center" justify="center">
                <div class="imgBlog">
                  <img
                    src="@/assets/images/blog/nogifts.jpg"
                    style="width:111px;"
                  />
                </div>
                <br /><br />
                <h4><b>Μοναδικά Προνόμια</b></h4>
                <br />
                <div class="paragraphBlog">
                  <p>
                    Κέρδισε επιπλέον πόντους απο προωθητικές ενέργειες της
                    <i><b>ελίν</b></i
                    >.
                  </p>
                </div>
              </v-col>
            </v-row>
            <template>
              <v-row justify="space-around">
                <v-col cols="auto" align="center" justify="center">
                  <v-dialog transition="dialog-top-transition" width="auto ">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          (promos && promos.length && activePromoExists) ||
                            promoWinnersExist ||
                            urlMore
                        "
                        class="button_beaut d-flex"
                        color="#004e96"
                        v-bind="attrs"
                        v-on="on"
                        :href="!!urlMore && urlMore"
                        rounded
                        >Δες περισσότερα</v-btn
                      >
                    </template>
                    <template>
                      <v-card
                        v-if="activePromoExists"
                        style="max-width: 500px;"
                      >
                        <v-toolbar><h4>Μοναδικά Προνόμια</h4></v-toolbar>
                        <v-img
                          :contain="true"
                          src="@/assets/images/promos/web_500x800.jpg"
                          class="pronomia col-md-12 col-lg-12 col-sm-12 col-12 text-center"
                        ></v-img>
                        <v-row justify="space-around" style="padding:20px">
                          <!-- <div v-for="(promo, i) in promos" :key="i"> -->
                          <v-dialog
                            transition="dialog-top-transition"
                            width="auto "
                            v-for="(promo, i) in promos"
                            :key="i"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-if="promo.expires > today"
                                class="button_beaut"
                                color="#004e96"
                                v-bind="attrs"
                                v-on="on"
                                rounded
                                style="padding: 0 15%; margin-top: 15px;"
                                >{{ promo.btnTitle }}</v-btn
                              >
                            </template>
                            <template>
                              <v-card>
                                <v-toolbar
                                  ><h4>{{ promo.btnTitle }}</h4></v-toolbar
                                >
                                <div style="padding:25px">
                                  <h3>{{ promo.title }}</h3>
                                  <p
                                    v-for="(term, ti) in promo.terms"
                                    :key="ti"
                                  >
                                    {{ term }}
                                  </p>

                                  <h4>Πρατήρια που συμμετέχουν</h4>
                                  <ul>
                                    <li
                                      v-for="(store, si) in promo.stores"
                                      :key="si"
                                    >
                                      {{ store }}
                                    </li>
                                  </ul>
                                </div>
                              </v-card>
                            </template>
                          </v-dialog>
                          <!-- </div> -->
                        </v-row>
                      </v-card>
                      <v-card
                        v-if="promoWinnersExist"
                        style="max-width: 500px;"
                      >
                        <v-toolbar><h4>Καύσιμα του καλοκαιριού</h4></v-toolbar>
                        <v-img
                          :contain="true"
                          src="@/assets/images/promos/newParticipant_ATTIKH_PUSH_1440X720.jpg"
                          class="pronomia col-md-12 col-lg-12 col-sm-12 col-12 text-center"
                        ></v-img>
                        <v-row justify="space-around" style="padding:20px">
                          <!-- <div v-for="(promo, i) in promos" :key="i"> -->
                          <div
                            transition="dialog-top-transition"
                            width="auto "
                            v-for="(promo, i) in promos"
                            :key="i"
                          >
                            <v-card
                              v-if="
                                promo.results && promo.results.expires > today
                              "
                            >
                              <v-toolbar
                                ><h4>
                                  {{ promo.results.description }}
                                </h4></v-toolbar
                              >
                              <div style="padding:25px">
                                <!-- <h3>{{ promo.title }}</h3> -->
                                <p
                                  v-for="(winner, ti) in promo.results.winners"
                                  :key="ti"
                                >
                                  {{ winner }}
                                </p>
                              </div>
                            </v-card>
                          </div>
                          <!-- </div> -->
                        </v-row>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </template>
          </div>
        </div>
      </div>
    </v-col>
    <!-- End Blog Area  -->
  </v-row>
</template>

<script>
import Modal from "@/components/modal/Modal";

export default {
  name: "GainPoints",
  components: {
    Modal,
  },
  data() {
    return {
      today: new Date(),
      urlMore: "https://elinup.marketing/",
      promos: [
        {
          expires: new Date("2022-07-15 23:59:59"),
          title: "«ΠΡΟΩΘΗΤΙΚΗ ΕΝΕΡΓΕΙΑ «ΚΕΡΔΙΣΕ ΤΑ ΚΑΥΣΙΜΑ ΤΟΥ ΚΑΛΟΚΑΙΡΙΟΥ» »",
          btnTitle: "Όροι χρήσης για Αττική",
          terms: [
            `H εταιρία με την επωνυμία ΕΛΙΝΟΙΛ ΕΛΛΗΝΙΚΗ ΕΤΑΙΡΙΑ ΠΕΤΡΕΛΑΙΩΝ ΑΕ διοργανώνει στο πλαίσιο του προγράμματος «ελίν up επιβράβευση», ηλεκτρονικό διαγωνισμό μέσω της εφαρμογής “ελίν up επιβράβευση” σε πρατήριά της που βρίσκονται στην Αθήνα και Ανατολική Στερεά . Ο ενδιαφερόμενος θα πρέπει να χρησιμοποιήσει την κάρτα «ελίν up επιβράβευση» ή την αντίστοιχη εφαρμογή «ελίν up επιβράβευση» μέσω του κινητού τηλεφώνου του. Θα αναδειχθούν είκοσι (20) νικητές που θα κερδίσουν ο καθένας τα καύσιμα του καλοκαιριού, μέσω 6 δωροεπιταγών των πενήντα (50) ευρώ, δηλαδή συνολικά 300 ευρώ (εφεξής «το δώρο») και είκοσι (20) επιλαχόντες.`,
            `Το δώρο αυτό είναι προσωπικό, δεν μεταβιβάζεται και δεν είναι ανταλλάξιμο ή εξαργυρώσιμο με χρήματα. Η ευθύνη της εταιρίας ΕΛΙΝΟΙΛ περιορίζεται αποκλειστικά και μόνο στην παράδοση κατά τον τρόπο που περιγράφεται κατωτέρω εκάστης δωροεπιταγής.`,
            `Ο κάθε συμμετέχων θα πρέπει να είναι κάτοχος της κάρτας «ελίν up επιβράβευση» ή να είναι εγγεγραμμένος στο ίδιο πρόγραμμα στην εφαρμογή “ελίν up επιβράβευση” της εταιρίας ΕΛΙΝΟΙΛ Α.Ε. και να προμηθευθεί καύσιμα 30 ευρώ και άνω. Εξαιρούνται οι εργαζόμενοι στην εταιρία ΕΛΙΝΟΙΛ Α.Ε., στα συμμετέχοντα πρατήρια καθώς και οι συγγενείς τους πρώτου βαθμού.`,
            `Η διάρκεια του διαγωνισμού ορίζεται από την Δευτέρα 27.6.2022 , ώρα 8.00 και θα λήξει την Παρασκευή 15.7.2022 και ώρα 23.59 Η εταιρία «ΕΛΙΝΟΙΛ» δύναται να τροποποιεί τη διάρκεια του Διαγωνισμού με σχετική ανακοίνωση στην σελίδα της στο Facebook.`,
            `Κάθε συναλλαγή αντιστοιχεί σε 1 συμμετοχή ενώ καθε συναλλαγη καυσίμων Crystal αντιστοιχεί σε 2 συμμετοχές. Κάθε ενδιαφερόμενος μπορεί να πραγματοποιήσει όσες συναλλαγές επιθυμεί και θα δικαιούται αντιστοίχων συμμετοχών με τον αριθμό των συναλλαγών του. Με κάθε συναλλαγή/συμμετοχή που πληροί τους όρους συμμετοχής ο ενδιαφερόμενος καταχωρείται αυτόματα στην κλήρωση.`,
            `Η ανάδειξη των νικητών θα γίνει με ηλεκτρονική κλήρωση, που θα διεξαχθεί με αυτοματοποιημένο τρόπο, ο οποίος δεν επιδέχεται ανθρώπινης παρέμβασης από εξουσιοδοτημένο ειδικά προς το σκοπό αυτό, υπάλληλο της εταιρίας, με χρήση ηλεκτρονικού υπολογιστή. Συγκεκριμένα η κλήρωση θα γίνει στις 18.7.2022, ημέρα Δευτέρα και ώρα 12.00.`,
            `Ο κάθε νικητής θα λάβει στο κινητό του τηλέφωνο τους κωδικούς έξι δωροεπιταγών αξίας 50€ έκαστη με διάρκεια 60 ημερών.`,
            `Αφού επιλέξει πρατήριο από την συνημμμένη στους παρόντες και αποτελούσα αναπόσπαστο τμήμα αυτών λίστα, θα το επισκεφθεί και επιδεικνύοντας τον κωδικό που αντιστοιχεί σε κάθε δωροεπιταγή θα την εξαργυρώσει εντός εξήντα (60) ημερών από την λήψη του κωδικού της προμηθευόμενος ισόποσης ή μεγαλύτερης αξίας καύσιμα (διευκρινίζεται ότι η κάθε δωροεπιταγή δεν μπορεί να εξαργυρωθεί τμηματικά πχ με καύσιμα αξίας 30 ευρώ και μεταγενέστερα 20 ευρώ). Η λήψη των κωδικών σε κάθε συμμετέχοντα θα επιβεβαιώνεται τηλεφωνικά από την εταιρία Roadcube. Σε περίπτωση που δεν ανευρεθεί τηλεφωνικά ο ενδιαφερόμενος για επιβεβαίωση λήψης των κωδικών για οποιονδήποτε λόγο, την θέση του λαμβάνει ο πρώτος επιλαχών κ.οκ.`,
            `Οι όροι συμμετοχής του διαγωνισμού έχουν αναρτηθεί στην ιστοσελίδα της διοργανώτριας εταιρίας «ΕΛΙΝΟΙΛ» www.elinup.gr.`,
            `Έγκυρες θεωρούνται οι συμμετοχές που έχουν λάβει χώρα εντός της διάρκειας του διαγωνισμού και για τις οποίες κάθε διαγωνιζόμενος έχει τηρήσει την διαδικασία συμμετοχής που περιγράφεται ανωτέρω, καθώς και το σύνολο των επιμέρους όρων του παρόντος, τους οποίους έχει αναγνώσει και έχει αποδεχθεί ανεπιφύλακτα με την συμμετοχή του στον Διαγωνισμό.`,
            `Η εταιρία « ΕΛΙΝΟΙΛ» μπορεί να ακυρώσει, κατά την απόλυτη κρίση της, οποιαδήποτε συμμετοχή θεωρεί ότι είναι προϊόν παράνομης τεχνικής επιρροής ή εν γένει απάτης ή αθέμιτης παρεμβολής του συμμετέχοντος ή τρίτου.`,
            `Η εταιρία «ΕΛΙΝΟΙΛ» δεν υποχρεούται να προβεί σε αντικατάσταση των δωροεπιταγών σε περίπτωση κλοπής, απώλειας ή καταστροφής των λογαριασμών ελίν up επιβράβευση. Με την ολοκλήρωση της κλήρωσης τα ονόματα των νικητών θα αναρτηθούν στην σελίδα Facebook της διοργανώτριας εταιρίας. Κάθε συμμετέχων παρέχει με μόνη την συμμετοχή του στον διαγωνισμό την ανεπιφύλαχτη συγκατάθεση του για ανάρτηση, για λόγους διαφάνειας, του ονοματεπώνυμού του στο Facebook της εταιρίας, σε περίπτωση νίκης του.`,
            `Η εταιρία «ΕΛΙΝΟΙΛ» διατηρεί το δικαίωμα να τροποποιήσει, ανακαλέσει, παρατείνει ή μειώσει τη διάρκεια του παρόντος Διαγωνισμού, κατά την κρίση της, καθώς και να μεταβάλει τους όρους και τις ημερομηνίες συμμετοχής ή/και να ματαιώσει τον Διαγωνισμό με σχετική ανακοίνωση στην σελίδα της στο Facebook . Σε καμία περίπτωση δεν ευθύνεται η εταιρία «ΕΛΙΝΟΙΛ» για τυχόν άμεσες ή έμμεσες ζημίες, δαπάνες και έξοδα που μπορεί να προκύψουν από τυχόν διακοπή , δυσλειτουργία της εφαρμογής «ελίν up επιβράβευση», καθυστέρηση ή οποιαδήποτε άλλη αιτία σχετικά με το δώρο του διαγωνισμού. Στην περίπτωση αυτή, οι συμμετέχοντες με την συμμετοχή τους στον παρόντα Διαγωνισμό αποδέχονται ανέκκλητα ότι δεν αποκτούν δικαίωμα ή απαίτηση κατά της διοργανώτριας εταιρίας, ούτε νομιμοποιούνται να ζητήσουν είτε την συνέχιση του λήξαντος διαγωνισμού. Οι συμμετέχοντες δεν έχουν ούτε αποκτούν κανένα απολύτως δικαίωμα στα σήματα, ονόματα, ενδείξεις εμβλήματα και λοιπά διακριτικά της εταιρίας «ΕΛΙΝΟΙΛ». Η συμμετοχή στο διαγωνισμό προϋποθέτει ανεπιφύλακτη αποδοχή των όρων συμμετοχής και συνεπάγεται τη συνακόλουθη παραίτηση από κάθε σχετική αξίωση έναντι της διοργανώτριας εταιρίας.`,
            `Μετά την εκπνοή της διάρκειας του Διαγωνισμού, της διανομής & της παράδοσης των δωροεπιταγών, κάθε υποχρέωση της διοργανώτριας εταιρίας παύει να υφίσταται, της τελευταίας μη υπέχουσας οποιαδήποτε υποχρέωση ή ευθύνη έναντι των συμμετεχόντων ή/και νικητών.`,
            `Προσωπικά δεδομένα.`,
            `Η συμμετοχή στον Διαγωνισμό συνεπάγεται τηρητή και ανεπιφύλακτη συναίνεση κάθε συμμετέχοντος για συλλογή, καταχώρηση, διατήρηση και επεξεργασία δεδομένων προσωπικού χαρακτήρα (όνομα, επώνυμο, ηλεκτρονική διεύθυνση, τηλέφωνο επικοινωνίας) σε αρχείο που θα τηρείται με αυτά από την ΕΛΙΝΟΙΛ, την διοργανώτρια εταιρία και την εταιρία Roadcube για το σκοπό διεκπεραίωσης του Διαγωνισμού, σύμφωνα με τις διατάξεις του Γενικού Κανονισμού Προστασίας Προσωπικών Δεδομένων (ΕΕ) 2016/679. Σκοπός της συλλογής, διατήρησης και επεξεργασίας των προσωπικών δεδομένων από τις ανωτέρω εταιρίες είναι η υποστήριξη των απαραίτητων δραστηριοτήτων στο πλαίσιο και μόνο για τους σκοπούς του συγκεκριμένου Διαγωνισμού. Οι συμμετέχοντες στον Διαγωνισμό, των οποίων τα στοιχεία θα ενταχθούν στο αρχείο έχουν δικαίωμα πρόσβασης σε αυτό και αντίρρησης, καθώς και αίτησης διαγραφής τους αναφορικά με τα δεδομένα που τα αφορούν, σύμφωνα με τις σχετικές διατάξεις του άνω Γενικού Κανονισμού. Σε οποιαδήποτε χρονική στιγμή ο εκάστοτε συμμετέχων διατηρεί το δικαίωμα πρόσβασης στα προσωπικά δεδομένα του και ενημέρωσης ή και αντίρρησης στην περαιτέρω επεξεργασία των στοιχείων του, καθώς και διαγραφής αυτών, βάσει των σχετικών διατάξεων του Γενικού Κανονισμού. Τα σχετικά δικαιώματα αυτά ασκούνται με την αποστολή επιστολής στην διεύθυνση Πηγών αρ. 33 -Κηφισιά 145 64 ή με ηλεκτρονικό μήνυμα στην Υπεύθυνη Προσωπικών Δεδομένων της Εταιρίας κα Στέλλα Καγιάννη στην ηλ. δ/νση dpo@elin.gr.`,
            `Οι παρόντες Όροι Συμμετοχής στο Διαγωνισμό βρίσκονται σε έντυπη μορφή σε όλα τα συμμετέχοντα στον διαγωνισμό πρατήρια. Οι Όροι Συμμετοχής στο Διαγωνισμό καθώς και οι οποιεσδήποτε τροποποιήσεις αυτών θα αναρτώνται στον Διαδικτυακό Τόπο της ΕΛΙΝΟΙΛ ΑΕ : www.elin.gr`,
            `Για οποιαδήποτε διαφορά τυχόν προκύψει από το Διαγωνισμό που αποτελεί αντικείμενο του παρόντος, αρμόδια δικαστήρια είναι τα Δικαστήρια των Αθηνών.`,
          ],
          stores: [
            "ELIN STATHMOI A.E. GLYKA NERA",
            "ELIN STATHMOI - VOULA",
            "Stamellos Konstantinos",
            "Nikolaou Eleni",
            "Excellent Fuels",
            "Mosxolidakis Emmanouil",
            "Kagkelis Stavros",
            "Kolimatsis Grigorios",
            "Kalatzopoulos Apostolos",
            "Keramida Maria",
            "PSX",
            "Giakoumatou Zoi - Georgaras Dimitrios O.E",
            "Zacharis Konstantinos",
            "ΒΟΤΣΗ ΣΟΦΙΑ",
            "ΒΑΡΕΛΑΣ ΠΑΝΑΓΙΩΤΗΣ",
            "Vs Oil",
            "Papadopoulou Stella & Papadopoulou Theodora",
            "ΝΑΣΗ ΑΛΕΚΟ",
            "Dimitris Fildisakos",
            "Nikia Despoina",
            "Andrianesis Dimitris",
            "Elin Massalis-Pipoglou-Floros",
            "ANDRI FUEL",
            "Manti Charoula",
            "Anagnostou Apostolis",
            "Gkatas Konstantinos",
            "Sioutis Nektarios",
            "Saplahidis Ioannis",
            "Pratiria Aliartou",
            "PanagiotouChristina",
            "MantIs Kostantinos",
            "Vakirtzi",
            "ΝΑΣΗ ΑΛΕΚΟ",
            "Kolias Konstantinos",
            "Karamplias Stefanos",
            "ΠΕΡΙΚΛΗΣ & ΙΩΑΝΝΗΣ ΒΙΕΝΝΑΣ",
            "Afoi Kokkali",
            "Nikolaou Athanasios",
            "Station Gas Kamatero",
            "Michail Ioannis",
            "Kamposos Dimitris",
            "Dimitris Fildisakos",
            "Soulos Nikolaos",
            "Mastoris Ilias",
            "PanagiotouChristina",
            "Vasiliou Spiros",
            "Stamellos Vasilios",
            "Gkikopoulos Stergios",
            "Avgerinakos Nikolaos & Euthimios",
            "Razos Ioannis",
          ],
          results: {},
        },
        {
          expires: new Date("2022-07-15 23:59:59"),
          title: "«ΠΡΟΩΘΗΤΙΚΗ ΕΝΕΡΓΕΙΑ «ΚΕΡΔΙΣΕ ΤΑ ΚΑΥΣΙΜΑ ΤΟΥ ΚΑΛΟΚΑΙΡΙΟΥ» »",
          btnTitle: "Όροι χρήσης για Θεσσαλονίκη",
          terms: [
            `H εταιρία με την επωνυμία ΕΛΙΝΟΙΛ ΕΛΛΗΝΙΚΗ ΕΤΑΙΡΙΑ ΠΕΤΡΕΛΑΙΩΝ ΑΕ διοργανώνει στο πλαίσιο του προγράμματος «ελίν up επιβράβευση», ηλεκτρονικό διαγωνισμό μέσω της εφαρμογής “ελίν up επιβράβευση” σε πρατήριά της που βρίσκονται στους νομούς Θεσσαλονίκης, Χαλκιδικής και Σερρών και συμμετέχουν στο πρόγραμμα ελίν up επιβράβευση. Ο ενδιαφερόμενος θα πρέπει να χρησιμοποιήσει την κάρτα «ελίν up επιβράβευση» ή την αντίστοιχη εφαρμογή «ελίν up επιβράβευση» μέσω του κινητού τηλεφώνου του. Θα αναδειχθούν δέκα (10) νικητές που θα κερδίσουν ο καθένας τα καύσιμα του καλοκαιριού, μέσω 6 δωροεπιταγών των πενήντα (50) ευρώ, δηλαδή συνολικά 300 ευρώ (εφεξής «το δώρο») και δέκα (10) επιλαχόντες.`,
            `Το δώρο αυτό είναι προσωπικό, δεν μεταβιβάζεται και δεν είναι ανταλλάξιμο ή εξαργυρώσιμο με χρήματα. Η ευθύνη της εταιρίας ΕΛΙΝΟΙΛ περιορίζεται αποκλειστικά και μόνο στην παράδοση κατά τον τρόπο που περιγράφεται κατωτέρω εκάστης δωροεπιταγής.`,
            `Ο κάθε συμμετέχων θα πρέπει να είναι κάτοχος της κάρτας «ελίν up επιβράβευση» ή να είναι εγγεγραμμένος στο ίδιο πρόγραμμα στην εφαρμογή “ελίν up επιβράβευση” της εταιρίας ΕΛΙΝΟΙΛ Α.Ε. και να προμηθευθεί καύσιμα Crystal 30 ευρώ και άνω. Εξαιρούνται οι εργαζόμενοι στην εταιρία ΕΛΙΝΟΙΛ Α.Ε., στα συμμετέχοντα πρατήρια καθώς και οι συγγενείς τους πρώτου βαθμού.`,
            `Η διάρκεια του διαγωνισμού ορίζεται από την Δευτέρα 27.6.2022 , ώρα 8.00 και θα λήξει την Παρασκευή 15.7.2022 και ώρα 23.59 Η εταιρία «ΕΛΙΝΟΙΛ» δύναται να τροποποιεί τη διάρκεια του Διαγωνισμού με σχετική ανακοίνωση στην σελίδα της στο Facebook.`,
            `Κάθε συναλλαγή αντιστοιχεί σε 1 συμμετοχή . Κάθε ενδιαφερόμενος μπορεί να πραγματοποιήσει όσες συναλλαγές επιθυμεί και θα δικαιούται αντιστοίχων συμμετοχών με τον αριθμό των συναλλαγών του. Με κάθε συναλλαγή/συμμετοχή που πληροί τους όρους συμμετοχής ο ενδιαφερόμενος καταχωρείται αυτόματα στην κλήρωση.`,
            `Η ανάδειξη των νικητών θα γίνει με ηλεκτρονική κλήρωση, που θα διεξαχθεί με αυτοματοποιημένο τρόπο, ο οποίος δεν επιδέχεται ανθρώπινης παρέμβασης από εξουσιοδοτημένο ειδικά προς το σκοπό αυτό, υπάλληλο της εταιρίας, με χρήση ηλεκτρονικού υπολογιστή. Συγκεκριμένα η κλήρωση θα γίνει στις 18.7.2022, ημέρα Δευτέρα και ώρα 12.00.`,
            `Ο κάθε νικητής θα λάβει στο κινητό του τηλέφωνο τους κωδικούς έξι δωροεπιταγών αξίας 50€ έκαστη με διάρκεια 60 ημερών.`,
            `Αφού επιλέξει πρατήριο από την συνημμμένη στους παρόντες και αποτελούσα αναπόσπαστο τμήμα αυτών λίστα, θα το επισκεφθεί και επιδεικνύοντας τον κωδικό που αντιστοιχεί σε κάθε δωροεπιταγή θα την εξαργυρώσει εντός εξήντα (60) ημερών από την λήψη του κωδικού της προμηθευόμενος ισόποσης ή μεγαλύτερης αξίας καύσιμα (διευκρινίζεται ότι η κάθε δωροεπιταγή δεν μπορεί να εξαργυρωθεί τμηματικά πχ με καύσιμα αξίας 30 ευρώ και μεταγενέστερα 20 ευρώ). Η λήψη των κωδικών σε κάθε συμμετέχοντα θα επιβεβαιώνεται τηλεφωνικά από την εταιρία Roadcube. Σε περίπτωση που δεν ανευρεθεί τηλεφωνικά ο ενδιαφερόμενος για επιβεβαίωση λήψης των κωδικών για οποιονδήποτε λόγο, την θέση του λαμβάνει ο πρώτος επιλαχών κ.οκ.`,
            `Οι όροι συμμετοχής του διαγωνισμού έχουν αναρτηθεί στην ιστοσελίδα της διοργανώτριας εταιρίας «ΕΛΙΝΟΙΛ» www.elinup.gr.`,
            `Έγκυρες θεωρούνται οι συμμετοχές που έχουν λάβει χώρα εντός της διάρκειας του διαγωνισμού και για τις οποίες κάθε διαγωνιζόμενος έχει τηρήσει την διαδικασία συμμετοχής που περιγράφεται ανωτέρω, καθώς και το σύνολο των επιμέρους όρων του παρόντος, τους οποίους έχει αναγνώσει και έχει αποδεχθεί ανεπιφύλακτα με την συμμετοχή του στον Διαγωνισμό.`,
            `Η εταιρία « ΕΛΙΝΟΙΛ» μπορεί να ακυρώσει, κατά την απόλυτη κρίση της, οποιαδήποτε συμμετοχή θεωρεί ότι είναι προϊόν παράνομης τεχνικής επιρροής ή εν γένει απάτης ή αθέμιτης παρεμβολής του συμμετέχοντος ή τρίτου.`,
            `Η εταιρία «ΕΛΙΝΟΙΛ» δεν υποχρεούται να προβεί σε αντικατάσταση των δωροεπιταγών σε περίπτωση κλοπής, απώλειας ή καταστροφής των λογαριασμών ελίν up επιβράβευση. Με την ολοκλήρωση της κλήρωσης τα ονόματα των νικητών θα αναρτηθούν στην σελίδα Facebook της διοργανώτριας εταιρίας. Κάθε συμμετέχων παρέχει με μόνη την συμμετοχή του στον διαγωνισμό την ανεπιφύλαχτη συγκατάθεση του για ανάρτηση, για λόγους διαφάνειας, του ονοματεπώνυμού του στο Facebook της εταιρίας, σε περίπτωση νίκης του.`,
            `Η εταιρία «ΕΛΙΝΟΙΛ» διατηρεί το δικαίωμα να τροποποιήσει, ανακαλέσει, παρατείνει ή μειώσει τη διάρκεια του παρόντος Διαγωνισμού, κατά την κρίση της, καθώς και να μεταβάλει τους όρους και τις ημερομηνίες συμμετοχής ή/και να ματαιώσει τον Διαγωνισμό με σχετική ανακοίνωση στην σελίδα της στο Facebook . Σε καμία περίπτωση δεν ευθύνεται η εταιρία «ΕΛΙΝΟΙΛ» για τυχόν άμεσες ή έμμεσες ζημίες, δαπάνες και έξοδα που μπορεί να προκύψουν από τυχόν διακοπή , δυσλειτουργία της εφαρμογής «ελίν up επιβράβευση», καθυστέρηση ή οποιαδήποτε άλλη αιτία σχετικά με το δώρο του διαγωνισμού. Στην περίπτωση αυτή, οι συμμετέχοντες με την συμμετοχή τους στον παρόντα Διαγωνισμό αποδέχονται ανέκκλητα ότι δεν αποκτούν δικαίωμα ή απαίτηση κατά της διοργανώτριας εταιρίας, ούτε νομιμοποιούνται να ζητήσουν είτε την συνέχιση του λήξαντος διαγωνισμού. Οι συμμετέχοντες δεν έχουν ούτε αποκτούν κανένα απολύτως δικαίωμα στα σήματα, ονόματα, ενδείξεις εμβλήματα και λοιπά διακριτικά της εταιρίας «ΕΛΙΝΟΙΛ». Η συμμετοχή στο διαγωνισμό προϋποθέτει ανεπιφύλακτη αποδοχή των όρων συμμετοχής και συνεπάγεται τη συνακόλουθη παραίτηση από κάθε σχετική αξίωση έναντι της διοργανώτριας εταιρίας .`,
            `Μετά την εκπνοή της διάρκειας του Διαγωνισμού, της διανομής & της παράδοσης των δωροεπιταγών, κάθε υποχρέωση της διοργανώτριας εταιρίας παύει να υφίσταται, της τελευταίας μη υπέχουσας οποιαδήποτε υποχρέωση ή ευθύνη έναντι των συμμετεχόντων ή/και νικητών.`,
            `Προσωπικά δεδομένα.`,
            `Η συμμετοχή στον Διαγωνισμό συνεπάγεται τηρητή και ανεπιφύλακτη συναίνεση κάθε συμμετέχοντος για συλλογή, καταχώρηση, διατήρηση και επεξεργασία δεδομένων προσωπικού χαρακτήρα (όνομα, επώνυμο, ηλεκτρονική διεύθυνση, τηλέφωνο επικοινωνίας) σε αρχείο που θα τηρείται με αυτά από την ΕΛΙΝΟΙΛ, την διοργανώτρια εταιρία και την εταιρία Roadcube για το σκοπό διεκπεραίωσης του Διαγωνισμού, σύμφωνα με τις διατάξεις του Γενικού Κανονισμού Προστασίας Προσωπικών Δεδομένων (ΕΕ) 2016/679. Σκοπός της συλλογής, διατήρησης και επεξεργασίας των προσωπικών δεδομένων από τις ανωτέρω εταιρίες είναι η υποστήριξη των απαραίτητων δραστηριοτήτων στο πλαίσιο και μόνο για τους σκοπούς του συγκεκριμένου Διαγωνισμού. Οι συμμετέχοντες στον Διαγωνισμό, των οποίων τα στοιχεία θα ενταχθούν στο αρχείο έχουν δικαίωμα πρόσβασης σε αυτό και αντίρρησης, καθώς και αίτησης διαγραφής τους αναφορικά με τα δεδομένα που τα αφορούν, σύμφωνα με τις σχετικές διατάξεις του άνω Γενικού Κανονισμού. Σε οποιαδήποτε χρονική στιγμή ο εκάστοτε συμμετέχων διατηρεί το δικαίωμα πρόσβασης στα προσωπικά δεδομένα του και ενημέρωσης ή και αντίρρησης στην περαιτέρω επεξεργασία των στοιχείων του, καθώς και διαγραφής αυτών, βάσει των σχετικών διατάξεων του Γενικού Κανονισμού. Τα σχετικά δικαιώματα αυτά ασκούνται με την αποστολή επιστολής στην διεύθυνση Πηγών αρ. 33 -Κηφισιά 145 64 ή με ηλεκτρονικό μήνυμα στην Υπεύθυνη Προσωπικών Δεδομένων της Εταιρίας κα Στέλλα Καγιάννη στην ηλ. δ/νση dpo@elin.gr.`,
            `Οι παρόντες Όροι Συμμετοχής στο Διαγωνισμό βρίσκονται σε έντυπη μορφή σε όλα τα συμμετέχοντα στον διαγωνισμό πρατήρια. Οι Όροι Συμμετοχής στο Διαγωνισμό καθώς και οι οποιεσδήποτε τροποποιήσεις αυτών θα αναρτώνται στον Διαδικτυακό Τόπο της ΕΛΙΝΟΙΛ ΑΕ : www.elin.gr`,
            `Για οποιαδήποτε διαφορά τυχόν προκύψει από το Διαγωνισμό που αποτελεί αντικείμενο του παρόντος, αρμόδια δικαστήρια είναι τα Δικαστήρια των Αθηνών.`,
          ],
          stores: [
            "ARKAS OIL",
            "Afoi Misailidi",
            "Athanasiadis G.- Athanasiadis N.",
            "Bavelis Christos",
            "Bavelis Christos",
            "Bozoglou Vasilios",
            "Chatziavraam Michail",
            "Chatzifotakis Menelaos",
            "Chatzistefanidis- Kirou",
            "Chatzivasiliou",
            "Deloglou Magdalini",
            "Doumplios Charalampos",
            "Doumplios Menelaos",
            "Emmanouil Aggela",
            "Giannoudis Dimitrios",
            "Giavridis Ioannis",
            "Intzidis Charalampos",
            "Intzidis Charalampos",
            "Karagiannidis Alexandros",
            "Karlopoulos Dimitrios",
            "Kavaloglou Stefanos",
            "Kiparissis Vasilios",
            "Kitsou Eleutheria",
            "Kligkopoulos Athanasios",
            "Kligkopoulos Iοannis & Geοrgios O.E",
            "KLIGOPOULOI BROS ΟΕ",
            "Kontotheodoros Dimitrios",
            "Kougioumtzis Achilleas",
            "Kougioumtzis Achilleas",
            "Koutroumanis Apostolos",
            "Liapis Ioannis",
            "Likourgiotis Stefanos",
            "Loukagos Vasilios",
            "Makris Konstantinos",
            "Maragkopoulos Christos",
            "Margariti Anastasia",
            "MIsailidis Arististidis",
            "Panagiotopoulos Vasilios",
            "Papapaulos Paulos",
            "Papavlos Ioakeim",
            "Siamtanidis Christos",
            "Tsaias Aristomenis",
            "Tselepis",
            "Tsipouras",
            "YIOI KΛΙΓΚΟΠΟΥΛΟΙ ΕΕ",
            "ΑΔΕΛΦΟΙ ΑΝΤ. ΧΡΗΣΤΟΥΛΑ Ο.Ε.",
            "ΕΛΕΥΘΕΡΙΟΣ ΒΟΥΡΛΙΩΤΗΣ & ΣΙΑ Ε.Ε.",
            "ΚΛΙΓΚΟΠΟΥΛΟΣ ΓΕΩΡΓΙΟΣ & ΚΛΙΓΚΟΠΟΥΛΟΣ ΙΩΑΝΝΗΣ Ο.E.",
            "ΧΑΤΖΗΛΙΔΗΣ ΙΩΣΗΦ",
          ],
          results: {},
        },
        {
          expires: new Date("2022-07-31 23:59:59"),
          title: "«ΠΡΟΩΘΗΤΙΚΗ ΕΝΕΡΓΕΙΑ «ΚΕΡΔΙΣΕ ΤΑ ΚΑΥΣΙΜΑ ΤΟΥ ΚΑΛΟΚΑΙΡΙΟΥ» »",
          btnTitle: "Όροι χρήσης για Τρίκαλα",
          terms: [
            `H εταιρία με την επωνυμία ΕΛΙΝΟΙΛ ΕΛΛΗΝΙΚΗ ΕΤΑΙΡΙΑ ΠΕΤΡΕΛΑΙΩΝ ΑΕ διοργανώνει στο πλαίσιο του
προγράμματος «ελίν up επιβράβευση», ηλεκτρονικό διαγωνισμό μέσω της εφαρμογής “ελίν up
επιβράβευση” σε πρατήριά της που βρίσκονται στον Νομό Τρικάλων και συμμετέχουν στο πρόγραμμα
ελίν up επιβράβευση. Ο ενδιαφερόμενος θα πρέπει να χρησιμοποιήσει την κάρτα «ελίν up
επιβράβευση» ή την αντίστοιχη εφαρμογή «ελίν up επιβράβευση» μέσω του κινητού τηλεφώνου του.
Θα αναδειχθούν τρεις (3) νικητές που θα κερδίσουν ο καθένας τα καύσιμα του καλοκαιριού, μέσω 6
δωροεπιταγών των πενήντα (50) ευρώ, δηλαδή συνολικά 300 ευρώ (εφεξής «το δώρο») και τρεις (3)
επιλαχόντες.`,
            `Το δώρο αυτό είναι προσωπικό, δεν μεταβιβάζεται και δεν είναι ανταλλάξιμο ή εξαργυρώσιμο με
χρήματα. Η ευθύνη της εταιρίας ΕΛΙΝΟΙΛ περιορίζεται αποκλειστικά και μόνο στην παράδοση κατά τον
τρόπο που περιγράφεται κατωτέρω εκάστης δωροεπιταγής.`,
            `Ο κάθε συμμετέχων θα πρέπει να είναι κάτοχος της κάρτας «ελίν up επιβράβευση» ή να είναι
εγγεγραμμένος στο ίδιο πρόγραμμα στην εφαρμογή “ελίν up επιβράβευση” της εταιρίας ΕΛΙΝΟΙΛ Α.Ε.
και να προμηθευθεί καύσιμα Crystal 30 ευρώ και άνω.`,
            `Εξαιρούνται οι εργαζόμενοι στην εταιρία ΕΛΙΝΟΙΛ Α.Ε., στα συμμετέχοντα πρατήρια καθώς και οι
συγγενείς τους πρώτου βαθμού.`,
            `Η διάρκεια του διαγωνισμού ορίζεται από την Δευτέρα 11.7.2022 , ώρα 8.00 έως την Κυριακή
31.7.2022 και ώρα 23.59. Η εταιρία «ΕΛΙΝΟΙΛ» δύναται να τροποποιεί τη διάρκεια του Διαγωνισμού με
σχετική ανακοίνωση στην σελίδα της στο Facebook ή στο www.elinup.gr`,
            `Κάθε συναλλαγή αντιστοιχεί σε 1 συμμετοχή . Κάθε ενδιαφερόμενος μπορεί να πραγματοποιήσει όσες
συναλλαγές επιθυμεί και θα δικαιούται αντιστοίχων συμμετοχών με τον αριθμό των συναλλαγών του.
Με κάθε συναλλαγή/συμμετοχή που πληροί τους όρους συμμετοχής ο ενδιαφερόμενος καταχωρείται
αυτόματα στην κλήρωση.`,
            `Η ανάδειξη των νικητών θα γίνει με ηλεκτρονική κλήρωση, που θα διεξαχθεί με αυτοματοποιημένο
τρόπο, ο οποίος δεν επιδέχεται ανθρώπινης παρέμβασης από εξουσιοδοτημένο ειδικά προς το σκοπό
αυτό, υπάλληλο της εταιρίας, με χρήση ηλεκτρονικού υπολογιστή. Συγκεκριμένα η κλήρωση θα γίνει
την 1/08/2022, ημέρα Δευτέρα και ώρα 12.00.`,
            `Ο κάθε νικητής θα λάβει στο κινητό του τηλέφωνο τους κωδικούς έξι δωροεπιταγών αξίας 50€ έκαστη.`,
            `Αφού επιλέξει πρατήριο από την κατωτέρω λίστα, θα το επισκεφθεί και επιδεικνύοντας τον κωδικό
που αντιστοιχεί σε κάθε δωροεπιταγή θα την εξαργυρώσει εντός εξήντα (60) ημερών από την λήψη
του κωδικού της προμηθευόμενος ισόποσης ή μεγαλύτερης αξίας καύσιμα (διευκρινίζεται ότι η κάθε
δωροεπιταγή δεν μπορεί να εξαργυρωθεί τμηματικά πχ με καύσιμα αξίας 30 ευρώ και μεταγενέστερα
20 ευρώ). Η λήψη των κωδικών σε κάθε συμμετέχοντα θα επιβεβαιώνεται τηλεφωνικά από την εταιρία
Roadcube. Σε περίπτωση που δεν ανευρεθεί τηλεφωνικά ο ενδιαφερόμενος για επιβεβαίωση λήψης
των κωδικών για οποιονδήποτε λόγο, την θέση του λαμβάνει ο πρώτος επιλαχών κ.οκ.`,
            `Οι όροι συμμετοχής του διαγωνισμού έχουν αναρτηθεί στην ιστοσελίδα της διοργανώτριας εταιρίας
«ΕΛΙΝΟΙΛ»: www.elinup.gr.`,
            `Έγκυρες θεωρούνται οι συμμετοχές που έχουν λάβει χώρα εντός της διάρκειας του διαγωνισμού και
για τις οποίες κάθε διαγωνιζόμενος έχει τηρήσει την διαδικασία συμμετοχής που περιγράφεται
ανωτέρω, καθώς και το σύνολο των επιμέρους όρων του παρόντος, τους οποίους έχει αναγνώσει και
έχει αποδεχθεί ανεπιφύλακτα με την συμμετοχή του στον Διαγωνισμό.`,
            `Η εταιρία « ΕΛΙΝΟΙΛ» μπορεί να ακυρώσει, κατά την απόλυτη κρίση της, οποιαδήποτε συμμετοχή
θεωρεί ότι είναι προϊόν παράνομης τεχνικής επιρροής ή εν γένει απάτης ή αθέμιτης παρεμβολής του
συμμετέχοντος ή τρίτου.`,
            `Η εταιρία «ΕΛΙΝΟΙΛ» δεν υποχρεούται να προβεί σε αντικατάσταση των δωροεπιταγών σε περίπτωση
κλοπής, απώλειας ή καταστροφής των λογαριασμών ελίν up επιβράβευση. Με την ολοκλήρωση της
κλήρωσης τα ονόματα των νικητών θα αναρτηθούν στην σελίδα Facebook της διοργανώτριας εταιρίας.
Κάθε συμμετέχων παρέχει με μόνη την συμμετοχή του στον διαγωνισμό την ανεπιφύλαχτη
συγκατάθεση του για ανάρτηση, για λόγους διαφάνειας, του ονοματεπώνυμού του στο Facebook της
εταιρίας, σε περίπτωση νίκης του.`,
            `Η εταιρία «ΕΛΙΝΟΙΛ» διατηρεί το δικαίωμα να τροποποιήσει, ανακαλέσει, παρατείνει ή μειώσει τη
διάρκεια του παρόντος Διαγωνισμού, κατά την κρίση της, καθώς και να μεταβάλει τους όρους και τις
ημερομηνίες συμμετοχής ή/και να ματαιώσει τον Διαγωνισμό με σχετική ανακοίνωση στην σελίδα της
στο Facebook ή στο www.elinup.gr`,
            `Σε καμία περίπτωση δεν ευθύνεται η εταιρία «ΕΛΙΝΟΙΛ» για τυχόν άμεσες ή έμμεσες ζημίες, δαπάνες
και έξοδα που μπορεί να προκύψουν από τυχόν διακοπή , δυσλειτουργία της εφαρμογής «ελίν up
επιβράβευση», καθυστέρηση ή οποιαδήποτε άλλη αιτία σχετικά με το δώρο του διαγωνισμού. Στην
περίπτωση αυτή, οι συμμετέχοντες με την συμμετοχή τους στον παρόντα Διαγωνισμό αποδέχονται
ανέκκλητα ότι δεν αποκτούν δικαίωμα ή απαίτηση κατά της διοργανώτριας εταιρίας, ούτε
νομιμοποιούνται να ζητήσουν είτε την συνέχιση του λήξαντος διαγωνισμού.`,
            `Οι συμμετέχοντες δεν έχουν ούτε αποκτούν κανένα απολύτως δικαίωμα στα σήματα, ονόματα,
ενδείξεις εμβλήματα και λοιπά διακριτικά της εταιρίας «ΕΛΙΝΟΙΛ».`,
            `Η συμμετοχή στο διαγωνισμό προϋποθέτει ανεπιφύλακτη αποδοχή των όρων συμμετοχής και
συνεπάγεται τη συνακόλουθη παραίτηση από κάθε σχετική αξίωση έναντι της διοργανώτριας εταιρίας .`,
            `Μετά την εκπνοή της διάρκειας του Διαγωνισμού, της διανομής & της παράδοσης των δωροεπιταγών,
κάθε υποχρέωση της διοργανώτριας εταιρίας παύει να υφίσταται, της τελευταίας μη υπέχουσας
οποιαδήποτε υποχρέωση ή ευθύνη έναντι των συμμετεχόντων ή/και νικητών.`,
            `Προσωπικά δεδομένα.`,
            `Η συμμετοχή στον Διαγωνισμό συνεπάγεται τηρητή και ανεπιφύλακτη συναίνεση κάθε συμμετέχοντος
για συλλογή, καταχώρηση, διατήρηση και επεξεργασία δεδομένων προσωπικού χαρακτήρα (όνομα,
επώνυμο, ηλεκτρονική διεύθυνση, τηλέφωνο επικοινωνίας) σε αρχείο που θα τηρείται με αυτά από την
ΕΛΙΝΟΙΛ, την διοργανώτρια εταιρία και την εταιρία Roadcube για το σκοπό διεκπεραίωσης του
Διαγωνισμού, σύμφωνα με τις διατάξεις του Γενικού Κανονισμού Προστασίας Προσωπικών Δεδομένων
(ΕΕ) 2016/679. Σκοπός της συλλογής, διατήρησης και επεξεργασίας των προσωπικών δεδομένων από
τις ανωτέρω εταιρίες είναι η υποστήριξη των απαραίτητων δραστηριοτήτων στο πλαίσιο και μόνο για
τους σκοπούς του συγκεκριμένου Διαγωνισμού. Οι συμμετέχοντες στον Διαγωνισμό, των οποίων τα
στοιχεία θα ενταχθούν στο αρχείο έχουν δικαίωμα πρόσβασης σε αυτό και αντίρρησης, καθώς και
αίτησης διαγραφής τους αναφορικά με τα δεδομένα που τα αφορούν, σύμφωνα με τις σχετικές
διατάξεις του άνω Γενικού Κανονισμού. Σε οποιαδήποτε χρονική στιγμή ο εκάστοτε συμμετέχων
διατηρεί το δικαίωμα πρόσβασης στα προσωπικά δεδομένα του και ενημέρωσης ή και αντίρρησης
στην περαιτέρω επεξεργασία των στοιχείων του, καθώς και διαγραφής αυτών, βάσει των σχετικών
διατάξεων του Γενικού Κανονισμού. Τα σχετικά δικαιώματα αυτά ασκούνται με την αποστολή
επιστολής στην διεύθυνση Πηγών αρ. 33 -Κηφισιά 145 64 ή με ηλεκτρονικό μήνυμα στην Υπεύθυνη
Προσωπικών Δεδομένων της Εταιρίας κα Στέλλα Καγιάννη στην ηλ. δ/νση dpo@elin.gr.`,
            `Οι Όροι Συμμετοχής στο Διαγωνισμό καθώς και οι οποιεσδήποτε τροποποιήσεις αυτών θα αναρτώνται
στον Διαδικτυακό Τόπο της ΕΛΙΝΟΙΛ ΑΕ : www.elin.gr ή ww.elinup.gr`,
            `Για οποιαδήποτε διαφορά τυχόν προκύψει από το Διαγωνισμό που αποτελεί αντικείμενο του
παρόντος, αρμόδια δικαστήρια είναι τα Δικαστήρια των Αθηνών.`,
          ],
          stores: [
            "ΑΦΟΙ ΑΡ. ΚΟΥΤΣΙΒΕΤΑ Ο.Ε.",
            "ΑΦΟΙ ΑΡ. ΚΟΥΤΣΙΒΕΤΑ Ο.Ε.",
            "ΑΦΟΙ ΑΡ. ΚΟΥΤΣΙΒΕΤΑ Ο.Ε.",
            "ΚΑΥΣΙΜΑ ΤΝΤ Ο.Ε.",
            "ΚΑΥΣΙΜΑ ΤΝΤ Ο.Ε.",
            "ΝΤΑΡΔΑΣ ΕΥΑΓΓΕΛΟΣ",
            "ΑΦΟΙ Γ. ΣΑΛΤΑΓΙΑΝΝΗ ΟΕ",
            "ΚΑΡΑΓΙΑΝΝΗΣ ΕΥΘΥΜΙΟΣ",
            "ΠΑΠΑΘΑΝΑΣΙΟΥ ΑΡΓΥΡΗΣ",
            "ΠΑΠΑΛΕΞΑΝΔΡΗ ΑΙΚΑΤΕΡΙΝΗ",
            "ΤΣΙΟΥΤΣΙΑΣ ΒΑΣΙΛΕΙΟΣ",
          ],
          results: {
            title: "Καύσιμα του καλοκαιριού",
            expires: new Date("2022-08-12 23:59:59"),
            description: "Νικητές διαγωνισμού στο Νομό Τρικάλων",
            winners: [
              "694****647 ΧΡΥΣΟΣΤΟΜΟΣ ΠΑΣΣΙΑΣ",
              "697****133 ΔΗΜΗΤΡΙΟΣ ΠΑΠΟΥΛΙΑΣ",
              "697****219 ΓΕΩΡΓΙΟΣ ΤΕΝΤΟΛΟΥΡΗΣ",
            ],
            // img:"newParticipant_ATTIKH_PUSH_1440X720.jpg"
          },
        },
        {
          expires: new Date("2022-07-31 23:59:59"),
          title: "«ΠΡΟΩΘΗΤΙΚΗ ΕΝΕΡΓΕΙΑ «ΚΕΡΔΙΣΕ ΤΑ ΚΑΥΣΙΜΑ ΤΟΥ ΚΑΛΟΚΑΙΡΙΟΥ» »",
          btnTitle: "Όροι χρήσης για Θράκη",
          terms: [
            `H εταιρία με την επωνυμία ΕΛΙΝΟΙΛ ΕΛΛΗΝΙΚΗ ΕΤΑΙΡΙΑ ΠΕΤΡΕΛΑΙΩΝ ΑΕ διοργανώνει στο πλαίσιο του
προγράμματος «ελίν up επιβράβευση», ηλεκτρονικό διαγωνισμό μέσω της εφαρμογής “ελίν up
επιβράβευση” σε πρατήριά της που βρίσκονται στους νομούς Ροδόπης, Ξάνθης, Έβρου και τα οποία
συμμετέχουν στο πρόγραμμα ελίν up επιβράβευση. Ο ενδιαφερόμενος θα πρέπει να χρησιμοποιήσει
την κάρτα «ελίν up επιβράβευση» ή την αντίστοιχη εφαρμογή «ελίν up επιβράβευση» μέσω του
κινητού τηλεφώνου του. Θα αναδειχθούν τρεις (3) νικητές που θα κερδίσουν ο καθένας τα καύσιμα
του καλοκαιριού, μέσω 6 δωροεπιταγών των πενήντα (50) ευρώ, δηλαδή συνολικά 300 ευρώ (εφεξής
«το δώρο») και τρεις (3) επιλαχόντες.`,
            `Το δώρο αυτό είναι προσωπικό, δεν μεταβιβάζεται και δεν είναι ανταλλάξιμο ή εξαργυρώσιμο με
χρήματα. Η ευθύνη της εταιρίας ΕΛΙΝΟΙΛ περιορίζεται αποκλειστικά και μόνο στην παράδοση κατά τον
τρόπο που περιγράφεται κατωτέρω εκάστης δωροεπιταγής.`,
            `Ο κάθε συμμετέχων θα πρέπει να είναι κάτοχος της κάρτας «ελίν up επιβράβευση» ή να είναι
εγγεγραμμένος στο ίδιο πρόγραμμα στην εφαρμογή “ελίν up επιβράβευση” της εταιρίας ΕΛΙΝΟΙΛ Α.Ε.
και να προμηθευθεί καύσιμα Crystal 30 ευρώ και άνω.`,
            `Εξαιρούνται οι εργαζόμενοι στην εταιρία ΕΛΙΝΟΙΛ Α.Ε., στα συμμετέχοντα πρατήρια καθώς και οι
συγγενείς τους πρώτου βαθμού.`,
            `Η διάρκεια του διαγωνισμού ορίζεται από την Δευτέρα 11.7.2022 , ώρα 8.00 και θα λήξει την Κυριακή
31.7.2022 και ώρα 23.59. Η εταιρία «ΕΛΙΝΟΙΛ» δύναται να τροποποιεί τη διάρκεια του Διαγωνισμού με
σχετική ανακοίνωση στην σελίδα της στο Facebook ή στο www.elinup.gr`,
            `Κάθε συναλλαγή αντιστοιχεί σε 1 συμμετοχή . Κάθε ενδιαφερόμενος μπορεί να πραγματοποιήσει όσες
συναλλαγές επιθυμεί και θα δικαιούται αντιστοίχων συμμετοχών με τον αριθμό των συναλλαγών του.
Με κάθε συναλλαγή/συμμετοχή που πληροί τους όρους συμμετοχής ο ενδιαφερόμενος καταχωρείται
αυτόματα στην κλήρωση.`,
            `Η ανάδειξη των νικητών θα γίνει με ηλεκτρονική κλήρωση, που θα διεξαχθεί με αυτοματοποιημένο
τρόπο, ο οποίος δεν επιδέχεται ανθρώπινης παρέμβασης από εξουσιοδοτημένο ειδικά προς το σκοπό
αυτό, υπάλληλο της εταιρίας, με χρήση ηλεκτρονικού υπολογιστή. Συγκεκριμένα η κλήρωση θα γίνει
την 1/08/2022, ημέρα Δευτέρα και ώρα 12.00.`,
            `Ο κάθε νικητής θα λάβει στο κινητό του τηλέφωνο τους κωδικούς έξι δωροεπιταγών αξίας 50€ έκαστη με διάρκεια 60 ημερών.`,
            `Αφού επιλέξει πρατήριο από την κατωτέρω λίστα, θα το επισκεφθεί και επιδεικνύοντας τον κωδικό
που αντιστοιχεί σε κάθε δωροεπιταγή θα την εξαργυρώσει εντός εξήντα (60) ημερών από την λήψη
του κωδικού της προμηθευόμενος ισόποσης ή μεγαλύτερης αξίας καύσιμα (διευκρινίζεται ότι η κάθε
δωροεπιταγή δεν μπορεί να εξαργυρωθεί τμηματικά πχ με καύσιμα αξίας 30 ευρώ και μεταγενέστερα
20 ευρώ). Η λήψη των κωδικών σε κάθε συμμετέχοντα θα επιβεβαιώνεται τηλεφωνικά από την εταιρία
Roadcube. Σε περίπτωση που δεν ανευρεθεί τηλεφωνικά ο ενδιαφερόμενος για επιβεβαίωση λήψης
των κωδικών για οποιονδήποτε λόγο, την θέση του λαμβάνει ο πρώτος επιλαχών κ.οκ.`,
            `Οι όροι συμμετοχής του διαγωνισμού έχουν αναρτηθεί στην ιστοσελίδα της διοργανώτριας εταιρίας
«ΕΛΙΝΟΙΛ»: www.elinup.gr.`,
            `Έγκυρες θεωρούνται οι συμμετοχές που έχουν λάβει χώρα εντός της διάρκειας του διαγωνισμού και
για τις οποίες κάθε διαγωνιζόμενος έχει τηρήσει την διαδικασία συμμετοχής που περιγράφεται
ανωτέρω, καθώς και το σύνολο των επιμέρους όρων του παρόντος, τους οποίους έχει αναγνώσει και
έχει αποδεχθεί ανεπιφύλακτα με την συμμετοχή του στον Διαγωνισμό.`,
            `Η εταιρία « ΕΛΙΝΟΙΛ» μπορεί να ακυρώσει, κατά την απόλυτη κρίση της, οποιαδήποτε συμμετοχή
θεωρεί ότι είναι προϊόν παράνομης τεχνικής επιρροής ή εν γένει απάτης ή αθέμιτης παρεμβολής του
συμμετέχοντος ή τρίτου.`,
            `Η εταιρία «ΕΛΙΝΟΙΛ» δεν υποχρεούται να προβεί σε αντικατάσταση των δωροεπιταγών σε περίπτωση
κλοπής, απώλειας ή καταστροφής των λογαριασμών ελίν up επιβράβευση. Με την ολοκλήρωση της
κλήρωσης τα ονόματα των νικητών θα αναρτηθούν στην σελίδα Facebook της διοργανώτριας εταιρίας.
Κάθε συμμετέχων παρέχει με μόνη την συμμετοχή του στον διαγωνισμό την ανεπιφύλαχτη
συγκατάθεση του για ανάρτηση, για λόγους διαφάνειας, του ονοματεπώνυμού του στο Facebook της
εταιρίας, σε περίπτωση νίκης του.`,
            `Η εταιρία «ΕΛΙΝΟΙΛ» διατηρεί το δικαίωμα να τροποποιήσει, ανακαλέσει, παρατείνει ή μειώσει τη
διάρκεια του παρόντος Διαγωνισμού, κατά την κρίση της, καθώς και να μεταβάλει τους όρους και τις
ημερομηνίες συμμετοχής ή/και να ματαιώσει τον Διαγωνισμό με σχετική ανακοίνωση στην σελίδα της
στο Facebook ή στο www.elinup.gr`,
            `Σε καμία περίπτωση δεν ευθύνεται η εταιρία «ΕΛΙΝΟΙΛ» για τυχόν άμεσες ή έμμεσες ζημίες, δαπάνες
και έξοδα που μπορεί να προκύψουν από τυχόν διακοπή , δυσλειτουργία της εφαρμογής «ελίν up
επιβράβευση», καθυστέρηση ή οποιαδήποτε άλλη αιτία σχετικά με το δώρο του διαγωνισμού. Στην
περίπτωση αυτή, οι συμμετέχοντες με την συμμετοχή τους στον παρόντα Διαγωνισμό αποδέχονται
ανέκκλητα ότι δεν αποκτούν δικαίωμα ή απαίτηση κατά της διοργανώτριας εταιρίας, ούτε
νομιμοποιούνται να ζητήσουν είτε την συνέχιση του λήξαντος διαγωνισμού.`,
            `Οι συμμετέχοντες δεν έχουν ούτε αποκτούν κανένα απολύτως δικαίωμα στα σήματα, ονόματα,
ενδείξεις εμβλήματα και λοιπά διακριτικά της εταιρίας «ΕΛΙΝΟΙΛ».`,
            `Η συμμετοχή στο διαγωνισμό προϋποθέτει ανεπιφύλακτη αποδοχή των όρων συμμετοχής και
συνεπάγεται τη συνακόλουθη παραίτηση από κάθε σχετική αξίωση έναντι της διοργανώτριας εταιρίας .`,
            `Μετά την εκπνοή της διάρκειας του Διαγωνισμού, της διανομής & της παράδοσης των δωροεπιταγών,
κάθε υποχρέωση της διοργανώτριας εταιρίας παύει να υφίσταται, της τελευταίας μη υπέχουσας
οποιαδήποτε υποχρέωση ή ευθύνη έναντι των συμμετεχόντων ή/και νικητών.`,
            `Προσωπικά δεδομένα.`,
            `Η συμμετοχή στον Διαγωνισμό συνεπάγεται τηρητή και ανεπιφύλακτη συναίνεση κάθε συμμετέχοντος
για συλλογή, καταχώρηση, διατήρηση και επεξεργασία δεδομένων προσωπικού χαρακτήρα (όνομα,
επώνυμο, ηλεκτρονική διεύθυνση, τηλέφωνο επικοινωνίας) σε αρχείο που θα τηρείται με αυτά από την
ΕΛΙΝΟΙΛ, την διοργανώτρια εταιρία και την εταιρία Roadcube για το σκοπό διεκπεραίωσης του
Διαγωνισμού, σύμφωνα με τις διατάξεις του Γενικού Κανονισμού Προστασίας Προσωπικών Δεδομένων
(ΕΕ) 2016/679. Σκοπός της συλλογής, διατήρησης και επεξεργασίας των προσωπικών δεδομένων από
τις ανωτέρω εταιρίες είναι η υποστήριξη των απαραίτητων δραστηριοτήτων στο πλαίσιο και μόνο για
τους σκοπούς του συγκεκριμένου Διαγωνισμού. Οι συμμετέχοντες στον Διαγωνισμό, των οποίων τα
στοιχεία θα ενταχθούν στο αρχείο έχουν δικαίωμα πρόσβασης σε αυτό και αντίρρησης, καθώς και
αίτησης διαγραφής τους αναφορικά με τα δεδομένα που τα αφορούν, σύμφωνα με τις σχετικές
διατάξεις του άνω Γενικού Κανονισμού. Σε οποιαδήποτε χρονική στιγμή ο εκάστοτε συμμετέχων
διατηρεί το δικαίωμα πρόσβασης στα προσωπικά δεδομένα του και ενημέρωσης ή και αντίρρησης
στην περαιτέρω επεξεργασία των στοιχείων του, καθώς και διαγραφής αυτών, βάσει των σχετικών
διατάξεων του Γενικού Κανονισμού. Τα σχετικά δικαιώματα αυτά ασκούνται με την αποστολή
επιστολής στην διεύθυνση Πηγών αρ. 33 -Κηφισιά 145 64 ή με ηλεκτρονικό μήνυμα στην Υπεύθυνη
Προσωπικών Δεδομένων της Εταιρίας κα Στέλλα Καγιάννη στην ηλ. δ/νση dpo@elin.gr.`,
            `Οι Όροι Συμμετοχής στο Διαγωνισμό καθώς και οι οποιεσδήποτε τροποποιήσεις αυτών θα αναρτώνται
στον Διαδικτυακό Τόπο της ΕΛΙΝΟΙΛ ΑΕ : www.elin.gr ή ww.elinup.gr`,
            `Για οποιαδήποτε διαφορά τυχόν προκύψει από το Διαγωνισμό που αποτελεί αντικείμενο του
παρόντος, αρμόδια δικαστήρια είναι τα Δικαστήρια των Αθηνών.`,
          ],
          stores: [
            "ΑΦΟΙ ΤΑΠΑΤΖΑ Ο.Ε",
            "ΑΙΒΑΖΙΔΗΣ ΗΛΙΑΣ",
            "ΑΥΓΕΡΗ ΚΩΝΣΤΑΝΤΙΝΙΑ",
            "BANTAK SABAN",
            "ΜΠΙΚΟΣ ΓΕΩΡΓΙΟΣ",
            "ΜΠΡΟΣΚΟΣ ΘΕΟΔΩΡΟΣ",
            "ΧΑΤΖΗΒΑΣΙΛΕΙΟΥ ΑΘΑΝΑΣΙΟΣ",
            "ΧΡΥΣΑΝΙΔΗΣ ΑΓΓΕΛΟΣ",
            "ΚΟΥΚΡΑΣ ΔΗΜΗΤΡΙΟΣ",
            "ΓΑΡΟΥΦΑΣ ΘΕΟΔΩΡΟΣ",
            "ΓΛΗΝΙΑΣ ΒΑΣΙΛΕΙΟΣ",
            "ΚΑΡΡΑΣ ΜΑΡΚΟΣ",
            "ΜΕΜΕΤ CHASAN GIASEMIN",
            "ΜΟΥΡΑΤΙΔΗΣ ΧΑΡΑΛΑΜΠΟΣ",
            "MOUSTAFA CHOULIA",
            "MOUZDAT MOUSTAFA",
            "ΝΤΟΥΜΑΝΙΔΗΣ ΚΑΙ ΣΙΑ Ι .Κ .Ε.",
            "ONBASH CHALIL",
            "ΠΑΡΑΣΚΕΥΑΣ ΙΟΡΔΑΝΗΣ-ΠΑΡΑΣΚΕΥΑΣ",
            "ΝΙΚΟΛΑΟΣ Ο.Ε",
            "ΘΕΟΔΩΡΙΔΟΥ ΧΡΥΣΑΝΘΗ",
            "ΘΕΟΔΩΡΟΥ ΜΙΧΑΗΛ",
            "ΒΑΘΡΑΚΕΑΣ ΧΡΙΣΤΟΔΟΥΛΟΣ",
            "Ι & Δ ΠΑΡΑΣΚΕΥΟΠΟΥΛΟΣ Ο.Ε",
            "ΤΖΕΛΕΠΗΣ Ο.E.",
          ],
          results: {},
        },
      ],

      blogContent: [
        {
          src: require("@/assets/images/logo/logo.png"),
          modalSrc: require("@/assets/images/blog/kausima_image2.png"),
          title: "Καύσιμα & Υπηρεσίες",
          titleModal: "Καύσιμα & Υπηρεσίες ελίν",
          description:
            "H ελίν σε επιβραβεύει για κάθε λίτρο καυσίμου και για κάθε προϊόν/υπηρεσία που επιλέγειςεπιλέγειςεπιλέγεις.         ",
          descriptionModal: "",
          imageWidth: "150",
        },
        {
          src: require("@/assets/images/blog/lip.png"),
          modalSrc: require("@/assets/images/blog/kausima_image2.png"),
          title: "Λιπαντικά",
          titleModal: "Λιπαντικά",
          description:
            "Aγόρασε λιπαντικά ελίν και επωφελήσου άμεσα με πόντους  <b><i>ελίν up</i> επιβράβευση</b>  για κάθε ευρώ αγορών.",
          descriptionModal: "",
          imageWidth: "120",
        },
        {
          src: require("@/assets/images/blog/electriconn.png"),
          modalSrc: require("@/assets/images/blog/Site_elin_gif.gif"),
          title: "Ηλεκτρική Ενέργεια Φυσικό Αέριο",
          titleModal: "Ηλεκτρική Ενέργεια / Φυσικό Αέριο",
          description:
            "Tώρα και οι πελάτες της Ηλεκτρικής Ενέργειας αλλά και του Φυσικού Αερίου απολαμβάνουν προνόμια.",
          descriptionModal: "",
          imageWidth: "150",
        },
        {
          src: require("@/assets/images/blog/fygame.png"),
          modalSrc: require("@/assets/images/blog/figamein.png"),
          title: "figame.gr",
          titleModal: "figame.gr",
          description:
            "Κάθε καταναλωτής που αγοράζει αεροπορικά εισιτήρια κερδίζει πόντους  <b><i>ελίν up</i> επιβράβευση</b> .",
          descriptionModal: "",
          imageWidth: "150",
        },
        {
          src: require("@/assets/images/blog/groupama.png"),
          modalSrc: require("@/assets/images/blog/Site_Elin_GROUPAMA.jpg"),
          title: "Groupama",
          titleModal: "Groupama",
          description:
            "Με κάθε νέα ασφάλιση groupama κερδίζετε 500 πόντους  <b><i>ελίν up</i> επιβράβευση</b> .",
          descriptionModal:
            "Κάθε πελάτης Groupama που θα κατεβάσει για πρώτη φορά την Εφαρμογή Roadcube, η Groupαma τον επιβραβεύει με 500 πόντους  <b><i>ελίν up</i> επιβράβευση</b> .",
          imageWidth: "150",
        },
        {
          src: require("@/assets/images/blog/nogifts.jpg"),
          modalSrc: require("@/assets/images/brand/kinito_elin.jpg"),
          title: "Μοναδικά Προνόμια",
          titleModal: "Μοναδικά Προνόμια",
          description:
            "Κέρδισε επιπλέον πόντους απο προωθητικές ενέργειες της ελίν.",
          descriptionModal: "",
          imageWidth: "10",
        },
      ],
    };
  },
  computed: {
    activePromoExists() {
      if (!this.promos || !this.promos.length) return false;
      for (let promo of this.promos) {
        if (promo.expires > this.today) return true;
      }
      return false;
    },
    promoWinnersExist() {
      if (!this.promos || !this.promos.length) return false;
      for (let promo of this.promos) {
        if (promo.results && promo.results.expires > this.today) return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.overflow-hidden {
  overflow: hidden;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.container-xl,
.container-lg,
.container-md,
.container-sm,
.container {
  max-width: 1234px;
}
.button_beaut:hover {
  background-color: white !important;
  color: #104788 !important;
  border: 1px solid #104788 !important;
}
.paragraphBlog {
  min-height: 150px;
}

.imgBlog {
  min-height: 100px;
}
// .v-image.pronomia .v-responsive__sizer{
//   padding-bottom: 250px !important
// }
</style>
